import { FuelTypography } from '@frete.com/fuel-react';
import { useField } from 'formik';
import RedCancel from '~components/svgs/RedCancel';
import * as Styled from './styled';

function withField(Component) {
  const NewComponent = ({
    className,
    trailingIcon,
    label,
    width,
    externalError,
    showTwoIcons,
    ...props
  }: any) => {
    const [field, { touched, error }, helpers] = useField(props);
    const isNotASelect = !props.options;
    const hasError = !!((touched && error) || externalError);
    const showCancelIcon = hasError && isNotASelect;

    const handleChange = (event) => {
      field.onChange(event);
      props?.onChange?.(event);
    };

    const handleClickCancel = () => {
      helpers.setValue('');
      helpers.setTouched(false);
    };

    const setColor = () => {
      return hasError
        ? 'danger-default'
        : props.disabled
        ? 'neutral-default'
        : 'inherit';
    };

    return (
      <Styled.FieldGroup $width={width} className={className}>
        <FuelTypography size="body-sm" weight="bold" color={setColor()}>
          {label}
        </FuelTypography>
        <Styled.RelativeWrapper $fieldGroupHasWidth={!!width} error={hasError}>
          <Component
            {...field}
            {...props}
            onChange={handleChange}
            id={props.name}
          />
          <Styled.TrailGroup>
            {showTwoIcons ? (
              <>
                {showCancelIcon && <RedCancel onClick={handleClickCancel} />}
                {trailingIcon && trailingIcon}
              </>
            ) : (
              <>
                {showCancelIcon ? (
                  <RedCancel onClick={handleClickCancel} />
                ) : (
                  trailingIcon && trailingIcon
                )}
              </>
            )}
          </Styled.TrailGroup>
        </Styled.RelativeWrapper>
        {hasError && (
          <FuelTypography size="caption" color="danger-default">
            {error || externalError}
          </FuelTypography>
        )}
      </Styled.FieldGroup>
    );
  };

  return NewComponent;
}

export default withField;
